/** Small display-string helpers shared across the dashboard views. */

/**
 * "1 domain" / "3 domains" — the count and its correctly-pluralized noun. Pass `plural` explicitly for
 * irregular nouns; the default just appends "s".
 */
export function plural(count: number, noun: string, pluralForm?: string): string {
  return `${count} ${count === 1 ? noun : (pluralForm ?? `${noun}s`)}`;
}
